import { type FC, useCallback, useEffect, useState } from "react";
import useAnimationVisibility from "@ch/helpers/hooks/useAnimationVisibility/useAnimationVisibility.ts";
import { ConstantsEnum } from "@ch/helpers/utils/enums.ts";
import useSendMsClaritySignal from "./hooks/useSendMsClaritySignal";

const CookieConsentBanner: FC = () => {
  const [sendClaritySignal, setSendClaritySignal] = useState(false);
  useSendMsClaritySignal(sendClaritySignal);

  const { handleClose, handleOpen, onAnimationEnd, visibility } =
    useAnimationVisibility({
      animationEndName: "animate__slideOutDown",
    });

  const animationClassNames = [
    "animate__animated",
    visibility.isVisible ? "animate__slideInUp" : "animate__slideOutDown",
  ];

  const handleAcceptCookies = useCallback(() => {
    if (!localStorage) return;

    localStorage.setItem(ConstantsEnum.ACCEPT_COOKIES, "true");

    setSendClaritySignal(true);

    handleClose();
  }, [handleClose]);

  useEffect(() => {
    if (!localStorage) return;

    const acceptCookies = localStorage.getItem(ConstantsEnum.ACCEPT_COOKIES);

    if (acceptCookies === "true" || acceptCookies === "false") {
      return;
    }

    setTimeout(() => handleOpen(), 1000);
  }, [handleOpen]);

  return visibility.isMounted ? (
    <div
      className={`fixed bottom-0 left-0 z-50 p-4 ${animationClassNames.join(" ")}`}
      onAnimationEnd={onAnimationEnd}
    >
      <div className="relative max-w-lg rounded-xl bg-white drop-shadow">
        <button
          aria-label="Close"
          className="btn btn-circle btn-ghost btn-sm absolute right-2 top-2"
          onClick={handleClose}
          type="button"
        >
          ✕
        </button>
        <div className="p-6">
          <div className="pt-6 sm:pr-6">
            <p>
              By clicking &quot;Accept Cookies&quot;, you agree to the storing
              of cookies on your device to enhance site navigation, analyze site
              usage, and assist in our marketing efforts.
            </p>
          </div>
          <div className="mt-6 flex flex-col">
            <button
              aria-label="Accept Cookies"
              className="h-[50px] rounded-full bg-[#ff632f] font-bold text-white"
              onClick={handleAcceptCookies}
              type="button"
            >
              Accept Cookies
            </button>
          </div>
        </div>
      </div>
    </div>
  ) : null;
};

export default CookieConsentBanner;
